module.exports = __webpack_public_path__ + "img/page-07.8f0f743c.jpg";